export const dayPageActions = [
    {
        title: 'Back',
        to: '/day-availability',
    },
];
